import {
  User,
  NavUser,
  LogoutIcon,
  SettingsIcon,
} from '@forgeglobal/design-framework';
import { getInitials } from '@tcs/common/utils/getInitials';
import useAuthentication from '@tcs/common/hooks/useAuthentication';
import { useNavigate } from 'react-router';
import useSession from '@tcs/client-portal-common/hooks/useSession';

const HeaderProfile = () => {
  const { signOut } = useAuthentication();
  const { claims, profile } = useSession();
  const firstName = profile?.personalInfo?.firstName || claims.given_name;
  const lastName = profile?.personalInfo?.lastName || claims.family_name;
  const suffix = profile?.personalInfo?.nameSuffix;
  const userInitials = getInitials(firstName, lastName);

  const fullname = [firstName, lastName, suffix].filter((n) => n).join(' ');
  const nav = useNavigate();

  const clickSignOut = () => {
    signOut();
  };

  const clickSettings = () => {
    nav('/profile/settings');
  };

  const listItems = [
    {
      text: 'Settings',
      icon: <SettingsIcon />,
      onClick: clickSettings,
    },
    {
      text: 'Sign out',
      icon: <LogoutIcon />,
      onClick: clickSignOut,
    },
  ];

  return (
    <NavUser
      avatar={<User data-test-id="user-icon">{userInitials}</User>}
      firstLine={fullname}
      listItems={listItems}
    />
  );
};

export default HeaderProfile;
